// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__ZTGno","logo":"Sidebar_logo__8p03A","website":"Sidebar_website__eo+NF","user":"Sidebar_user__MBOZo"};